const STORAGE_PREFIX = "slopify-context-prefs:";

export const OPTIONAL_CONTEXT_LAYERS = [
  "existingData",
  "siblingInteractions",
  "sceneMetadata",
  "projectContext",
  "projectGroup",
  "scenarIaOrigin",
] as const;

export type OptionalContextLayer = (typeof OPTIONAL_CONTEXT_LAYERS)[number];

export const MANDATORY_CONTEXT_LAYERS = ["language", "humanPrompt", "task"] as const;

const keyFor = (contentId: number): string => `${STORAGE_PREFIX}${contentId}`;

export const getExcludedLayers = (contentId: number): OptionalContextLayer[] => {
  try {
    const raw = localStorage.getItem(keyFor(contentId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((v): v is OptionalContextLayer =>
      (OPTIONAL_CONTEXT_LAYERS as readonly string[]).includes(v),
    );
  } catch {
    return [];
  }
};

export const setExcludedLayers = (contentId: number, excluded: OptionalContextLayer[]): void => {
  try {
    const unique = Array.from(new Set(excluded)).filter((v) =>
      (OPTIONAL_CONTEXT_LAYERS as readonly string[]).includes(v),
    );
    if (unique.length === 0) {
      localStorage.removeItem(keyFor(contentId));
    } else {
      localStorage.setItem(keyFor(contentId), JSON.stringify(unique));
    }
  } catch {
    /* ignore quota */
  }
};
